import { render, staticRenderFns } from "./ComparisonTable.vue?vue&type=template&id=63099172&lang=pug"
import script from "./ComparisonTable.vue?vue&type=script&lang=ts"
export * from "./ComparisonTable.vue?vue&type=script&lang=ts"
import style0 from "./ComparisonTable.vue?vue&type=style&index=0&id=63099172&prod&lang=css&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoreBlock: require('/app/components/generic/CoreBlock.vue').default})
